import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { AddBorrowerComponent } from '../add-borrower/add-borrower.component';

@Component({
	selector: 'app-borrowers-array',
	templateUrl: './borrowers-array.component.html',
	styleUrls: ['./borrowers-array.component.scss']
})
export class BorrowersArrayComponent implements OnInit {
	@Input() public borrowersArray: FormArray;
	@Input() public displayErrors: boolean;
	@Input() public qID: any;
	@Input() public childrenNumber: number[];
	@Input() public maritalStatus: string[];
	@Input() public showRemove: boolean=false;


	@Output() onAddFormGroup: EventEmitter<any> = new EventEmitter<any>();

	maxBorrowerCount = 3;

	constructor() { }

	ngOnInit() {
	}

	addBorrower() {
		this.displayErrors = this.borrowersArray.invalid;
		if (this.borrowersArray.valid) {
			let newBorrowerId = this.borrowersArray.value.length + 1;

			this.borrowersArray.push(AddBorrowerComponent.buildBorrower({
				borrowerId: newBorrowerId.toString()
			}));
			this.onAddFormGroup.emit();
		}
	}

	simulateClick(event) {
		if ( event.keyCode === 13 ){
		  event.currentTarget.click();
		} 
	 }

	static builBorrowers(value: any) {
		let arr: FormGroup[] = [];
		if (value && value.length > 0) {
			value.forEach(element => {
				if(element.fields[0].answerValue) {
					arr.push(new FormGroup({
						borrowerProximity: new FormControl({value: element.fields[0].answerValue || "", disabled: element.fields[0].answerValue === "בן/בת זוג" ? true : false}),
						borrowerFullName: new FormControl(element.fields[1].answerValue || ""),
						borrowerIdNumber: new FormControl(element.fields[2].answerValue || ""),
						borrowerPhoneNumber: new FormControl(element.fields[3].answerValue || ""),
						borrowerBirthDate: new FormControl(element.fields[4].answerValue || ""),
						borrowerEmail: new FormControl(element.fields[5].answerValue || ""),
						borrowerId: new FormControl(element.borrowerId || "")
					}))
				}
			});
		}
		return new FormArray(arr);
	}

	static builAdvancedBorrowers(borrowers: any, answer: any, question1Step4?) {
		if (borrowers.length>0 && answer) {
			let advanceBorrowersFormArr: FormGroup[] = [];
			let advanceBorrowersArr = borrowers.map(r => {
				let bId = r.borrowerId;
				let filtered = answer.filter(a => a.borrowerId === bId)[0];
				filtered.fields[0].answerValue = r.fields[0].answerValue;
				if(question1Step4 && r.fields[4].answerValue === "בן/בת זוג"){
					filtered.fields[1].answerValue = question1Step4.answer.fields[0].answerValue;
					filtered.fields[2].answerValue = question1Step4.answer.fields[2].answerValue;
					filtered.fields[3].answerValue = question1Step4.answer.fields[3].answerValue;
				}
				return filtered;
			});
			
			
			advanceBorrowersArr.forEach(element => {
				console.log(element	);
			let zugDisable  = element.fields[3].answerValue === "נשוי"? true : false;
			let valueStatus = element.fields[3].answerValue === "נשוי"?  "נשוי" : "";
				
				advanceBorrowersFormArr.push(new FormGroup({
					borrowerFullName: new FormControl({
						value: element.fields[0].answerValue || "",
						disabled: true
					}),
					borrowerAddress: new FormControl({
						value: element.fields[1].answerValue || "",
						disabled: zugDisable
				}),
					borrowerChildrenNumber: new FormControl({
						value: element.fields[2].answerValue || "",
						disabled: zugDisable
				}),
					borrowerMaritalStatus: new FormControl({
						value: valueStatus,
						disabled: zugDisable
				}),
					borrowerId: new FormControl(element.borrowerId || "")	
				}))
			});
			console.log("*************************", advanceBorrowersArr)
			return new FormArray(advanceBorrowersFormArr);
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/borrowers-array/borrowers-array.component.ts